import http from "../utils/http-common";

class VehicleReplacementTypeDataService {
  getAll() {
    return http.get("/vehicle-replacement-type");
  }

  get(id) {
    return http.get(`/vehicle-replacement-type/${id}`);
  }

  create(data) {
    return http.post("/vehicle-replacement-type", data);
  }

  update(id, data) {
    return http.put(`/vehicle-replacement-type/${id}`, data);
  }

  delete(id) {
    return http.delete(`/vehicle-replacement-type/${id}`);
  }
}

export default new VehicleReplacementTypeDataService();
